module.exports = __webpack_public_path__ + "static/media/G1-35-Katherine Adamopoulos-cod70.46fc71b4.png";